import React from 'react';
import '../Estilos/Estilo.scss';
import { Paginacion,getCurrentPage } from '../util/paginacion';
import Spinner from "react-bootstrap/Spinner";


class TECH extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id:props.id,
			tech: props.tech,
            currentPagetech:1,
            loadingtech:true,
            techActuales:[],
            itemPerPage:props.item,
            vacia : false
            
		};
        if(this.state.tech.length<=0){
            this.state.vacia = true;
        }
      }
    render(){
        return(	
        <div>
        <div>

        {/*{this.state.vacia ? <h1>No hay tecnologías que mostrar</h1> : ''}*/}
        {this.setState({techActuales:this.state.tech.slice((this.state.currentPagetech - 1) * this.state.itemPerPage, this.state.currentPagetech * this.state.itemPerPage),loadingtech:false})}

        {this.state.loadingtech & !this.state.vacia ? <Spinner /> :
            this.state.techActuales.map((
                {title,type, authors,link,date,numReg})=>{		
            return(					
                <div class='tech-card' on >

                    <div class="description">
            
                        <h1><b>{title}</b></h1>
                        <p>
                            <b>Type: </b>{type}
                            <br/>
                            {authors.length>1?<b>Authors: </b>:<b>Author: </b>}
                            {authors.map((name, currentValue)=>{return(<text>{name} {currentValue< authors.length-1?';':''}</text>)})}
                            <br/>
                                <b>Date: </b>{date}
                            <br/>
                            {numReg.length<=0 ?'':
                               <text> <b>Registry Number: </b>{numReg}<br/></text>
                            }
                            <a href={link}><b>Link</b></a><br/>
                            
                        </p>
                    </div>

                </div>  
            );
        
         })}
        </div>
        <Paginacion id={this.state.id} itemPerPage ={this.state.itemPerPage} length={this.state.tech.length}/>
        {this.setState({currentPagetech:getCurrentPage(this.state.id)})}
        </div>
        );
        
    }
}

 export default TECH;